export default {
  unsaved: {
    title: 'Wijzigingen opslaan?',
    description: 'Je hebt wijzigingen aangebracht in deze stap die nog niet zijn opgeslagen.',
    discard: 'Verwerpen',
    save_and_continue: 'Opslaan en doorgaan',
  },
  title: 'Uw restaurant instellen',
  nav: {
    completed: 'Voltooid',
    locked: 'Wordt beheerd door uw provider',
    aria_label: 'Lanceerstappen',
    step_label: 'Stap {{number}}',
    section_label: 'Lancering',
    back_to_home: 'Terug naar Home',
  },
  owner_invite: {
    hint: 'Wilt u dat de restauranteigenaar de configuratie zelf afrondt? Nodig hen uit en ze gaan verder waar u gebleven bent.',
    sent: 'Uitnodiging verzonden naar {{name}} ({{email}}) op {{date}}.',
  },
  footer: {
    step_of: 'Stap {{current}} van {{total}}',
  },
  buttons: {
    next_task: 'Volgende taak',
    cancel: 'Annuleren',
    back: 'Terug',
    next: 'Doorgaan',
    save: 'Opslaan',
    exit: 'Configuratie verlaten',
    retry: 'Opnieuw proberen',
  },
  errors: {
    progress_load_failed: 'We konden de voortgang van de configuratie voor dit restaurant niet laden.',
    linked_company_unavailable:
      'Deze link is voor een restaurant dat u niet kunt openen, dus u bevindt zich op uw huidige.',
  },
  placeholder: {
    title: 'Deze stap komt binnenkort',
    description: 'De wizardshell en voortgangsregistratie zijn gereed. Deze fase wordt als volgende gebouwd.',
  },
  new_restaurant: {
    title: 'Nieuw restaurant',
    menu: {
      title: 'Menu',
      description: 'Een demo slaat onboarding over, importeer het menu nu.',
    },
    demo: {
      title: 'Nieuwe demo',
      description: 'Een demorestaurant voor testen — het slaat het grootste deel van de onboarding over.',
      label: 'Demo aanmaken',
    },
    description: 'Vertel ons waar dit restaurant is. We zoeken het op in Google Maps.',
  },
  location: {
    edit_description: 'Locatie van dit restaurant bijwerken.',
    cta: 'Restaurant aanmaken',
    section: {
      address: 'Basisinformatie',
      group: 'Merk',
      group_description: 'Maakt deze locatie deel uit van een merk dat je al hebt?',
    },
    form: {
      name: {
        label: 'Restaurantnaam',
        placeholder: 'Zoek naar uw restaurant…',
        help: 'Begin met typen om Google Maps te doorzoeken naar dit restaurant.',
      },
      address: {
        label: 'Straatadres',
        placeholder: 'Straat en huisnummer',
      },
      city: {
        label: 'Stad',
      },
      zip_code: {
        label: 'Postcode',
      },
      country: {
        label: 'Land',
      },
      region: {
        label: 'Staat / Regio',
        placeholder: 'Selecteer een staat of regio',
      },
    },
    group: {
      aria_label: 'Merkopties',
      deferred_hint: 'Je kiest de merknaam en het webadres in de laatste stap.',
      existing: {
        title: 'Toevoegen aan bestaand merk',
        description: 'Een extra locatie onder een merk dat je al runt.',
        select_label: 'Merk',
        select_placeholder: 'Selecteer een merk',
      },
      new: {
        title: 'Nieuw merk aanmaken',
        description: 'Eén restaurant, of de eerste locatie van een nieuw merk.',
      },
    },
    toasts: {
      update_failed: 'De locatie kon niet worden opgeslagen. Probeer het opnieuw.',
      created: 'Restaurant aangemaakt',
      create_failed: 'Het restaurant kon niet worden aangemaakt. Probeer het opnieuw.',
    },
  },
  domain: {
    url_setup: {
      title: 'Online bestel-adres',
      description: 'Waar gasten bestellingen plaatsen.',
    },
    modes: {
      foodamigos: {
        host_fallback: 'je domein voor online bestellen',
        title: 'Gebruik ons standaarddomein',
      },
      custom: {
        title: 'Koppel je eigen domein',
        description: 'Gebruik een domein dat het restaurant al bezit.',
      },
    },
    toasts: {
      save_failed: 'Kan het online bestel-adres niet opslaan. Probeer het opnieuw.',
    },
  },
  go_live: {
    subtitle: 'Controleer of elke stap is voltooid en zet live bestellingen aan.',
    slug: {
      // Answers the open question in round-2 §8: PartialUpdateFranchiseRequest
      // carries no go-live guard on the slug, so it can be changed at any time —
      // but there is no redirect table, so the previous address stops resolving.
      // Saying so removes the hesitation without overpromising.
      help: 'Alleen letters, cijfers en koppeltekens. Je kunt dit later wijzigen, maar het oude adres werkt dan niet meer.',
      title: 'Online bestel-adres',
      description: 'Hier bestellen uw klanten. U kunt dit later wijzigen.',
      label: 'Personaliseer het met de restaurantnaam',
      placeholder: 'bella-italia',
      preview: 'Je bestelpagina:',
      save: 'URL opslaan',
      saved: 'Online bestel-adres opgeslagen',
      save_failed: 'Kon de URL niet opslaan. Probeer opnieuw.',
      status: {
        checking: 'Beschikbaarheid controleren…',
        available: 'Beschikbaar',
        taken: 'Deze URL is al in gebruik',
        invalid: 'Gebruik alleen letters, cijfers, koppeltekens en underscores',
        error: 'Beschikbaarheid kon niet worden gecontroleerd — probeer het opnieuw',
      },
    },
    domain: {
      title: 'Eigen domein (optioneel)',
      description: 'Gebruik je eigen domein in plaats van het door FoodAmigos verstrekte adres.',
      add: '+ Eigen domein toevoegen',
      hide: 'Eigen domein verbergen',
      label: 'Uw domein',
      placeholder: 'shop.myrestaurant.com',
      save: 'Opslaan',
      show_records: 'DNS-records weergeven',
      hint: 'Alleen voor bestellingen — uw website heeft een ander domein nodig. Bijvoorbeeld order.mijnrestaurant.nl voor de shop en mijnrestaurant.nl voor de website.',
      records_after_save:
        'Zodra u het domein opslaat, laten we precies zien welke records u bij uw DNS-provider moet toevoegen — een hoofddomein (mijnrestaurant.nl) en een subdomein (order.mijnrestaurant.nl) hebben verschillende nodig.',
      saved: 'Eigen domein opgeslagen',
      save_failed: 'Kon het domein niet opslaan. Probeer opnieuw.',
      unconfirmed: {
        title: 'Live gaan wacht niet op dit domein',
        description:
          'Zolang de records ervan niet zijn bevestigd, blijft de bestelpagina op het standaardadres en kan het restaurant daar live gaan. Zodra ze zijn bevestigd — dit kan tot 48 uur duren — toont het domein de bestelpagina automatisch.',
      },
    },
    locations: {
      title: 'Locaties bevestigen',
      description: 'Elke locatie binnen je merk krijgt een eigen bestel-adres. Bevestig of wijzig ze hieronder.',
      save: 'Locaties opslaan',
      saved: "Locatie-URL's opgeslagen",
      save_failed: "Kon een of meer locatie-URL's niet opslaan. Probeer opnieuw.",
    },
    preflight: {
      title: 'Voordat u live gaat',
      description: 'Voltooi dit om live bestellingen in te schakelen.',
      url_setup: 'Bestel-adres ingesteld',
      online_payment: {
        your_provider: 'je provider',
        payments_live: '{{title}} · voltooid',
        online_payments_off: '{{title}} · geen online betalingen',
        waiting_for_provider: '{{title}} · wachten op {{provider}}',
        hosted_not_finished: '{{title}} · afronden bij {{provider}}',
        action_needed: '{{title}} · actie vereist',
        waiting_for_partner: '{{title}} · wachten op je partner',
        not_set_up: '{{title}} · niet ingesteld',
        business_details_missing: '{{title}} · voeg bedrijfsgegevens voor uitbetalingen toe',
      },
    },
    failed_checks: {
      title: 'Nog een paar zaken vereisen aandacht',
      items: {
        name: 'Restaurantnaam',
        logo_url: 'Logo',
        pictures: "Galerijfoto's",
        menu_uploaded: 'Menu',
        opening_hours: 'Openingstijden',
        address: 'Adres',
        storefront: 'Bestel-adres',
        payments_configured: 'Betalingen',
        stripe_billing: 'Facturering',
        test_orders: 'Testbestelling',
        google_business: 'Google Business-profiel',
        master_promo_code: 'Welkomstpromotiecode',
        flyers_ordered: 'Flyers besteld',
        identity: 'Restauranttype en keukens',
        billing_payment_method: 'Betaalmethode',
        billing_license: 'Licentie',
        business_name: 'Bedrijfs- / restaurantnaam',
        payment_method: 'Contant of online betalen',
        stripe_processing_fee: 'Verwerkingskosten partner',
      },
      force: 'Toch live gaan',
      blocker: '(verplicht)',
      link: 'Partnerfacturering openen',
    },
    error: 'Kon live bestellingen niet inschakelen. Probeer opnieuw.',
    gate_hint: 'Voltooi de checklist hierboven om Live gaan in te schakelen.',
    business_name: {
      label: 'Bedrijfs- / restaurantnaam',
      help: 'Staat in je gebruiksvoorwaarden en privacybeleid. Gebruik de naam waaronder je bedrijf handelt.',
      save: 'Opslaan',
      save_failed: 'De bedrijfsnaam kon niet worden opgeslagen. Probeer het opnieuw.',
      hint: 'Sla eerst de bedrijfs- / restaurantnaam op.',
    },
    cash_only: {
      message:
        'Online betalingen staan uit — klanten kunnen alleen contant betalen bij afhalen of bezorgen totdat een gateway is gekoppeld en geverifieerd.',
    },
    payment_blocked: {
      title: 'Schakel contant betalen in of stel online betalingen in om live te gaan.',
      payment_method: 'Klanten hebben een betaalmethode nodig.',
      turn_on_cash: 'Contant betalen inschakelen',
      ask_partner: 'Vraag je partner om contant betalen in te schakelen, of',
      set_up_online: 'stel online betalingen in',
    },
    buttons: {
      go_live: 'Live gaan 🚀',
      finish: 'Installatie voltooien',
    },
    celebration: {
      title: 'U bent live!',
      title_named: '{{name}} is live!',
      subtitle: 'Uw restaurant accepteert nu live bestellingen.',
      license: '{{plan}} · actief',
      license_trial: '{{plan}} · gratis tot {{date}}',
      finish: 'Installatie voltooien',
    },
    service_fee: {
      title: 'Servicekosten',
      headline: 'Verdien extra omzet zonder je restaurants iets te rekenen',
      subtitle:
        'Voeg een kleine servicevergoeding toe die gasten bij het afrekenen betalen. Jij houdt de helft. De vergoeding staat uit totdat je hem aanzet.',
      subtitle_share:
        'Voeg een kleine servicevergoeding toe die gasten bij het afrekenen betalen. Jij houdt {{share}}%. De vergoeding staat uit totdat je hem aanzet.',
      tiles: {
        guest: {
          title: 'Betaald door de gast',
          description: 'Zichtbaar bij het afrekenen, zoals bij bezorgapps.',
        },
        share: {
          title: 'De helft is voor jou',
          title_share: '{{share}}% is voor jou',
          description: 'Verdeeld {{share}}/{{rest}} met FoodAmigos.',
        },
        choice: {
          title: 'Jouw keuze',
          description: 'Standaard uit. Altijd te wijzigen.',
        },
      },
      preview: {
        title: 'Wat gasten bij het afrekenen zouden zien',
        subtotal: 'Subtotaal bestelling',
        fee: 'Servicekosten',
        fee_terms: '({{percentage}}%, max. {{max}})',
        guest_pays: 'Gast betaalt',
        split_partner: '<strong>Jij {{amount}}</strong> per bestelling',
        split_provider: 'FoodAmigos {{amount}}',
        unchanged: 'De bestelwaarde van het restaurant blijft gelijk.',
      },
      earnings: {
        title: 'Wat je bij dit restaurant kunt verdienen',
        orders: 'Online bestellingen per maand',
        average_order: 'Gemiddelde bestelling',
        per_month: 'per maand voor jou',
        collected: '{{amount}} per maand van gasten ontvangen. Jouw aandeel: {{share}}%. Slechts een schatting.',
        effective_rate: 'Effectief vergoedingspercentage over alle bestellingen: {{rate}}',
      },
      choice: {
        question: 'Servicevergoeding toevoegen voor dit restaurant?',
        enabled: {
          title: 'Servicevergoeding toevoegen',
          recommended: 'Aanbevolen: {{percentage}}%, max. {{max}}',
          description: 'Gasten betalen een kleine vergoeding. Jij verdient een deel.',
        },
        skipped: {
          title: 'Geen servicevergoeding',
          description: 'Gasten betalen alleen de menuprijzen.',
        },
      },
      footer: {
        enabled:
          'Gasten betalen {{percentage}}%, max. {{max}} per bestelling. Wijzig dit op elk moment via <settings>Bestelinstellingen → Servicevergoeding</settings>.',
        skipped:
          'Voorlopig geen servicevergoeding. Wijzig dit op elk moment via <settings>Bestelinstellingen → Servicevergoeding</settings>.',
      },
      enabled:
        'De servicekosten zijn nu actief voor dit restaurant met {{percentage}}%, met een maximum van {{max}} per bestelling. Ze worden vanaf nu op alle nieuwe bestellingen toegepast. Wijzig dit op elk moment in <settings>Bestelinstellingen → Servicekosten</settings>.',
      enabled_partner_default:
        'De servicekosten zijn nu actief voor dit restaurant. Uw standaardinstelling als partner geldt: {{percentage}}%, met een maximum van {{max}} per bestelling. Ze worden vanaf nu op alle nieuwe bestellingen toegepast. Wijzig dit op elk moment in <settings>Bestelinstellingen → Servicekosten</settings>.',
      buttons: {
        enable: 'Servicekosten inschakelen',
        continue_without: 'Doorgaan zonder vergoeding',
      },
      skipped:
        'Gasten van dit restaurant betalen geen servicekosten. U kunt ze op elk moment inschakelen in <settings>Bestelinstellingen → Servicekosten</settings>.',
      toasts: {
        save_failed: 'De keuze voor servicekosten kon niet worden opgeslagen. Probeer het opnieuw.',
      },
    },
  },
  toasts: {
    save_failed: 'Kon uw wijzigingen niet opslaan. Probeer opnieuw.',
    saved: 'Opgeslagen',
  },
  optional: 'Optioneel',
  identity: {
    min_cuisine_hint: 'Selecteer minimaal één keukentype om door te gaan.',
    sections: {
      restaurant_type: {
        title: 'Restauranttype',
        description: 'Wat voor soort etablissement is dit?',
      },
      cuisine: {
        title: 'Keukentypen',
        description: 'Kies er minimaal één.',
      },
    },
  },
  menu: {
    modes: {
      recommended: 'Aanbevolen',
      import: {
        title: 'Importeren van een platform',
        description: 'Haal het menu op uit GloriaFood, Wolt, Lieferando, Deliveroo en meer.',
      },
      manual: {
        title: 'Menu zelf opbouwen',
        description: 'Maak categorieën en items handmatig aan in de menubouwer.',
      },
    },
    import: {
      title: 'Importeren van bestaand platform',
      in_progress: {
        title: 'Menu importeren…',
        description: 'Dit duurt meestal minder dan twee minuten. We voltooien deze stap zodra het klaar is.',
      },
      failed: {
        title: 'De import is niet voltooid',
        description: 'De menuimport kon niet worden voltooid. Controleer de gegevens en probeer opnieuw.',
      },
      blocked: {
        until: 'Gepauzeerd tot {{time}}',
        release: 'Link vrijgeven',
        released: 'Link vrijgegeven. Je kunt de import opnieuw starten.',
        release_failed: 'De link kon niet worden vrijgegeven. Probeer het over een moment opnieuw.',
      },
      stalled: {
        title: 'Nog aan het importeren…',
        description:
          'De import duurt langer dan gebruikelijk. Het kan nog op de achtergrond lopen — controleer het zo opnieuw. Een nieuwe import starten kan het menu twee keer importeren.',
      },
    },
    manual: {
      title: 'Menu zelf opbouwen',
      description:
        'De menubouwer opent met een leeg menu. Deze stap is voltooid zodra er minimaal één categorie en één item zijn.',
      open_editor: 'Menubouwer openen',
      waiting: {
        title: 'Wachten op uw eerste menu-item',
        description: 'Zodra u een item toevoegt in de menu-editor, kan deze stap worden voltooid.',
      },
      found: {
        title: 'Menu-items gedetecteerd',
        description: 'Goed — u kunt doorgaan naar de volgende stap.',
      },
    },
    complete: {
      title: 'Menu klaar',
      description: 'Uw menu is klaar. U kunt het altijd bekijken vanuit de menu-editor.',
    },
    buttons: {
      start_import: 'Import starten',
      importing: 'Importeren…',
      retry: 'Import opnieuw proberen',
      check_again: 'Opnieuw controleren',
      continue: 'Doorgaan',
      skip: 'Nu overslaan',
    },
  },
  phases: {
    // Stands in for the restaurant name in phase descriptions before it is known.
    fallback_name: 'dit restaurant',
    location: {
      title: 'Locatie',
      description: 'Waar bevindt het restaurant zich en bij welk merk hoort het?',
    },
    identity: {
      title: 'Identiteit',
      description: 'Restauranttype en keukens.',
    },
    brand: {
      title: 'Merk',
      description: 'Logo, kleuren en galerij.',
    },
    operations: {
      title: 'Locatiegegevens',
      description:
        'Stel in hoe {{name}} bestellingen aanneemt. Dit is het minimum dat vereist is voordat bestellingen ontvangen kunnen worden.',
    },
    menu: {
      title: 'Menu',
      description:
        'Zet het menu van {{name}} op het platform. Importeer het in minder dan twee minuten van een bestaand platform, of bouw het zelf op.',
    },
    domain: {
      title: 'Domein',
      description: 'Het webadres waarmee klanten bij dit restaurant bestellen.',
    },
    go_live: {
      title: 'Live gaan',
      description: 'Live bestellingen inschakelen.',
    },
    payouts: {
      title: 'Online betaling',
      description: 'Hoe dit restaurant online betalingen ontvangt.',
    },
    service_fee: {
      title: 'Servicekosten',
      description:
        'Of gasten bij het afrekenen servicekosten betalen. Je kunt dit later wijzigen via Bestelinstellingen → Kosten.',
    },
    bank_account: {
      title: 'Bankrekening',
      description:
        'Waar uitbetalingen naartoe gaan. Niet nodig om live te gaan: betalingen blijven in het saldo staan totdat er een rekening is toegevoegd.',
    },
  },
  business_details: {
    locked:
      'Deze gegevens zijn geverifieerd bij je betalingsprovider. Neem contact op met FoodAmigos om ze te wijzigen.',
    section: {
      title: 'Bedrijfsgegevens',
    },
    fields: {
      business_type: {
        label: 'Bedrijfstype',
        options: {
          company: 'Bedrijf (GmbH, UG, Ltd, Inc — een geregistreerde rechtspersoon)',
          individual: 'Eenmanszaak (jij bezit en runt het bedrijf persoonlijk)',
        },
      },
      owner_first_name: { label: 'Voornaam eigenaar' },
      owner_last_name: { label: 'Achternaam eigenaar' },
      legal_name: {
        label: 'Wettelijke bedrijfsnaam',
        individual:
          'Jij runt het bedrijf persoonlijk, dus de naam van de eigenaar wordt gebruikt als wettelijke bedrijfsnaam.',
      },
      legal_address: { label: 'Geregistreerd adres' },
      legal_city: { label: 'Stad' },
      legal_state: { label: 'Provincie of staat' },
      legal_zip_code: { label: 'Postcode' },
      legal_country: { label: 'Land' },
      tax_id: {
        generic: 'Belasting- of registratienummer',
        personal: 'Alleen de laatste vier cijfers worden getoond. Laat het ongewijzigd om het nummer te behouden.',
        hint: 'Bijvoorbeeld {{example}}.',
        invalid:
          'Dit komt niet overeen met het gebruikelijke formaat voor dit land en bedrijfstype, bijvoorbeeld {{example}}.',
      },
      is_vat_registered: { label: 'Dit bedrijf is btw-plichtig' },
      vat_id: {
        label: 'Btw-nummer',
        help: 'Begint met {{country}}, gevolgd door 8 tot 12 letters of cijfers.',
        invalid: 'Het btw-nummer moet beginnen met {{country}}, gevolgd door 8 tot 12 letters of cijfers.',
        help_unprefixed: 'Uw btw- of belastingregistratienummer, zoals uitgegeven.',
        invalid_unprefixed: 'Dit lijkt geen btw-nummer: gebruik 5 tot 25 letters of cijfers.',
      },
    },
    toasts: {
      save_failed: 'Kan je bedrijfsgegevens niet opslaan. Probeer het opnieuw.',
    },
  },
  brand: {
    fields: {
      short_name: {
        label: 'Korte naam',
        placeholder: 'bijv. Amigo Pizza',
        tooltip: 'Een kortere weergavenaam voor de winkel en bonnen.',
      },
      primary_color: {
        label: 'Primaire kleur',
        invalid: 'Voer een geldige hexkleur in, bijv. #1A73E8.',
      },
    },
    sections: {
      short_name: 'Naam',
      short_name_hint: 'Gebruikt in de winkel, op bonnen en in meldingen.',
      logo_and_colour: 'Logo en primaire merkkleur',
      logo: 'Logo uploaden',
      logo_hint: 'Als u dit leeg laat, wordt het logo van uw merk gebruikt.',
      gallery: "Galerijfoto's",
      gallery_hint: "Voeg maximaal {{max}} foto's van uw restaurant toe. Sleep om te herordenen.",
      gallery_count: '{{count}} van {{max}} toegevoegd',
    },
    toasts: {
      image_uploaded: 'Afbeelding geüpload',
      image_upload_failed: 'Kon de afbeelding niet uploaden. {{error}}',
      save_failed: 'Kon uw merkgegevens niet opslaan. Probeer het opnieuw.',
    },
  },
  operations: {
    contact: {
      title: 'Contact',
      description: 'Gebruikt voor bestelnotificaties en klantcommunicatie.',
      phone: {
        label: 'Telefoonnummer restaurant',
        placeholder: '+49 30 1234567',
        invalid: 'Voer een volledig internationaal telefoonnummer in, bijv. +49 30 1234567',
      },
      email: { label: 'E-mailadres restaurant', placeholder: 'bestellingen@restaurant.com' },
    },
    methods: {
      title: 'Bestelmethoden',
      description: 'Hoe klanten kunnen bestellen en hoe lang elke methode duurt.',
      pickup: {
        label: 'Afhalen',
        prep_time: { label: 'Gemiddelde bereidingstijd (min)' },
      },
      delivery: {
        label: 'Bezorging',
        delivery_time: { label: 'Gemiddelde bezorgtijd (min)' },
        advanced_zones: 'Geavanceerde zone-instelling',
      },
    },
    timing: {
      title: 'Besteltiming',
      description: 'Wanneer klanten bestellingen kunnen plaatsen — nu, later of van tevoren.',
      at_least_one: 'Schakel zo snel mogelijk of geplande bestelling in (minimaal één vereist).',
      asap: { label: 'Zo snel mogelijk-bestellingen accepteren' },
      scheduled: { label: 'Geplande bestellingen accepteren' },
      reminders: { label: 'Stuur een automatische herinnering voordat een geplande bestelling verwacht wordt' },
      pre_order: {
        label: 'Voorbestellingen voor toekomstige dagen toestaan',
        days: { label: 'Hoeveel dagen vooruit (0-31)' },
      },
    },
    tax: {
      title: 'Btw',
      description:
        'Het tarief dat op de producten van dit restaurant wordt toegepast. Het begint met het tarief voor de regio — wijzig dit alleen als dit restaurant iets anders in rekening brengt.',
      rate: { label: 'Btw-tarief', placeholder: 'bijv. 7' },
      dedicated: { label: 'Btw verschilt per product' },
    },
    hours: {
      title: 'Openingstijden',
      description: 'De dagen en tijden waarop dit restaurant bestellingen accepteert.',
      same_every_day: 'Elke dag dezelfde tijden',
      split_shifts: {
        title: 'Dit restaurant heeft gesplitste openingstijden',
        description:
          'Sommige dagen hebben meer dan één openingsperiode (bijvoorbeeld een lunch- en een dinershift). De eenvoudige editor toont één periode per dag, dus we bewaren uw huidige tijden zoals ze zijn — bewerk gesplitste shifts bij Bestelinstellingen → Openingstijden.',
      },
    },
    toasts: {
      save_failed: 'Kon uw operationele instellingen niet opslaan. Probeer het opnieuw.',
    },
  },
  online_payment: {
    question: 'Wil je online betalingen accepteren voor dit restaurant?',
    yes: 'Ja',
    not_now: 'Niet nu',
    declined:
      'Klanten betalen bij afhalen of bezorging. Je kunt online betalen op elk moment inschakelen via Instellingen.',
    providers: {
      stripe: 'Stripe',
      adyen: 'Adyen',
    },
    waiting_for_partner: {
      staff: {
        title: 'Betalingen zijn nog niet ingesteld voor je partneraccount',
        description:
          'Een beheerder van je partneraccount moet kiezen wie de betalingen verwerkt voordat dit restaurant online betalingen kan ontvangen. Je kunt ondertussen doorgaan met de andere stappen.',
      },
    },
    continue_to_go_live: 'Doorgaan naar Live gaan',
    platform_line: 'Betalingen voor dit restaurant lopen via FoodAmigos payments.',
    only_connection: 'Betalingen lopen via {{name}} (je enige gekoppelde provider).',
    partner_issue: {
      title: 'Uw partner {{partner}} moet de configuratie van hun betaalprovider nog afronden',
      description:
        'Hun betaalprovider kan nog geen restaurants onboarden. We hebben hen op de hoogte gebracht — uw gegevens zijn opgeslagen, kom terug zodra zij bevestigen dat het klaar is.',
      retry_hint: 'Zodra het is opgelost, gaat u opnieuw door naar de provider en proberen wij het opnieuw.',
      open_settings: 'Open de instellingen van uw betalingsgateway',
    },
    connect_another: 'Nog een provider koppelen',
    checking: 'Controleren bij {{provider}}…',
    checking_generic: 'Controleren bij de betalingsprovider…',
    retry: 'Opnieuw proberen',
    not_set_up: {
      title: 'Nog geen betalingsprovider gekoppeld',
      description:
        'Je partner koppelt een betalingsprovider aan dit restaurant. Zodra dat is gebeurd, kun je hier de instelling afronden.',
    },
    choice: {
      title: 'Welke van je gekoppelde providers moet dit restaurant gebruiken?',
      primary: 'Primair',
      confirm: 'Gebruik deze provider',
      cancel: 'Annuleren',
    },
    using: 'Gebruikt {{name}}',
    change: 'Wijzigen',
    payout_details: {
      title: 'Bedrijfsgegevens voor uitbetalingen',
      description: 'Nodig voor de betaalprovider om je bedrijf te verifiëren en uitbetalingen te doen.',
      business_type: {
        company: {
          title: 'Bedrijf',
          description: 'GmbH, bv, Ltd, Inc — een geregistreerde rechtspersoon',
        },
        individual: {
          title: 'Individueel',
          description: 'Je bent persoonlijk eigenaar en runt het bedrijf zelf',
        },
      },
      registered_address: 'Geregistreerd adres',
      legal_address: 'Straatadres',
      legal_state: 'Staat / regio',
      vat_id: 'Btw-nummer',
      optional: '(optioneel)',
      fill_first: 'Vul eerst hierboven de bedrijfsgegevens voor uitbetalingen in.',
    },
    hand_off: {
      title: 'Volgende: rond de configuratie af bij {{provider}}',
      description:
        '{{provider}} vraagt in een eigen formulier om het identiteitsbewijs van de eigenaar, op basis van de bedrijfsgegevens voor uitbetalingen hierboven. Ongeveer 10 minuten. De bankrekening volgt na het livegaan.',
      cta: 'Doorgaan naar {{provider}}',
      transition: 'Je wordt doorgestuurd naar {{provider}}…',
      error: 'Het {{provider}}-formulier kon niet worden geopend. Probeer het opnieuw.',
    },
    states: {
      verified: 'Betalingen zijn live.',
      submitted: {
        title: 'Gegevens verzonden naar {{provider}}',
        description: 'Verificatie duurt meestal 1–2 werkdagen. We e-mailen de restauranteigenaar zodra het klaar is.',
        description_email:
          'Verificatie duurt meestal 1–2 werkdagen. We sturen een e-mail naar {{email}} zodra het klaar is.',
        review: {
          business_type: 'Bedrijfstype',
          legal_name: 'Wettelijke naam',
          address: 'Geregistreerd adres',
          types: {
            company: 'Bedrijf',
            individual: 'Individueel',
          },
        },
      },
      incomplete: {
        title: 'Je bent nog niet klaar met {{provider}}',
        description: 'Je gegevens zijn opgeslagen — de link is 2 dagen geldig.',
        expired: 'Je gegevens zijn opgeslagen, maar de link is verlopen.',
        cta: 'Doorgaan met {{provider}}',
        new_link: 'Nieuwe link ophalen en doorgaan',
        check_details: 'Mijn gegevens eerst controleren',
      },
      action_needed: {
        title: '{{provider}} heeft nog iets nodig',
        description:
          '{{provider}} kon een van je gegevens niet verifiëren. Open hun formulier opnieuw om dit te herstellen.',
        cta: 'Open het {{provider}}-formulier opnieuw',
      },
    },
    connected: {
      title: 'Betalingen verlopen via {{name}}',
      description:
        'Dit restaurant is gekoppeld aan het account van {{name}} — verder hoeft hier niets ingesteld te worden.',
      failed: 'We konden dit restaurant nog niet koppelen aan {{name}}',
    },
    errors: {
      generic: 'Er is iets misgegaan. Probeer het opnieuw.',
      load_failed: 'We konden de betalingsinstellingen van dit restaurant niet laden.',
    },
  },
  bank_account: {
    section: {
      title: 'Bankrekening voor uitbetalingen',
      description:
        'Uitbetalingen worden verstuurd in {{currency}}, de valuta waarin dit restaurant betalingen ontvangt.',
    },
    done: 'Terug naar dashboard',
    load_failed: 'We konden de bankrekening van dit restaurant niet laden.',
    retry: 'Opnieuw proberen',
    no_permission: 'Alleen de eigenaar van het restaurant of de partner kan de bankrekening invoeren.',
    confirm_with_provider: 'Bevestigen bij Adyen',
    toasts: {
      save_failed: 'We konden de bankrekening niet opslaan. Controleer de gegevens.',
    },
  },
  payouts: {
    finish_setup: 'Installatie voltooien',
  },
};
